module.exports = __webpack_public_path__ + "static/img/prize02.b18ed754.png";